export default __webpack_public_path__ + "static/en-2-9b20823fc7f82a4a1532aeb9f29155cc.svg";